<template>
  <div class="root">
    <TopGuide />
    <ChangeCompany :hide="true"/>
    <div class="invoice-header" v-if="!this.$route.meta.hideHeader">
      <div v-if="this.$route.meta.withGoBack" class="iconfont back" @click="goBack">&#xe682;</div>
      <div class="invoice-title">{{this.$route.name}}</div>
      <div v-if="this.$route.meta.showClear" class="iconfont right" @click="clearApply">清除</div>
    </div>
    <div class="invoice-main" ref="layout">
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>
import ChangeCompany from '@components/ChangeCompany'
import TopGuide from '@components/TopGuide/index.vue'
export default {
  data: () => {
    return {
    }
  },
  mounted () {
  },

  methods: {
    goBack () {
      if (this.$route.name === '申请列表') {
        this.$router.push('/')
      } else {
        this.$router.go(-1)
      }
    },
    clearApply () {
      this.$store.commit('invoice/initApplyData')
      this.$store.commit('invoice/changeGoodsList', [])
    }
  },
  watch: {
    $route (to, from) {
      if (to.meta.keepAlive && to.path !== from.path) {
        this.$router.go(0)
      }
    }
  },
  components: {
    ChangeCompany,
    TopGuide
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
